import { render, staticRenderFns } from "./EcoPopup.vue?vue&type=template&id=6b009da5&scoped=true"
import script from "./EcoPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./EcoPopup.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./EcoPopup.vue?vue&type=style&index=0&id=6b009da5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b009da5",
  null
  
)

export default component.exports